/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'components/Image';
import { getPreviewPassWelcomeDelay } from 'helpers/ConfigHelper';
import { MILLISECONDS } from 'helpers/DateTimeHelper';
import Style from 'themes/styleguide/nation/Auth/PreviewPassWelcome.module.scss';

const PreviewPassWelcome = ({
  sharedTheme,
  networkLogo,
  children,
  rendered,
  dismiss,
  backgroundUrl,
}) => {
  if (!rendered) return null;
  const [isRunning, setIsRunning] = useState(false);
  const delay = getPreviewPassWelcomeDelay();
  const innerContainerStyle = backgroundUrl && { backgroundImage: `url('${backgroundUrl}')` };
  const image = networkLogo && <Image source={networkLogo} className={Style.image} alt="" />;
  const containerClass = classNames(sharedTheme.container, Style.container);
  const innerContainerClasses = classNames(sharedTheme.innerContainer, Style.innerContainer);
  const progressBarStyle = isRunning ? { transition: `width ${delay}s`, width: '100%' } : {};
  const progressBar = (
    <div className={Style.progress}>
      <div className={Style.done} style={progressBarStyle} />
    </div>
  );

  useEffect(() => {
    setIsRunning(true);
    setTimeout(dismiss, delay * MILLISECONDS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={containerClass}>
      <div className={innerContainerClasses} style={innerContainerStyle}>
        <div className={Style.content}>
          {image}
          {children}
          {progressBar}
        </div>
      </div>
    </div>
  );
};

PreviewPassWelcome.propTypes = {
  sharedTheme: PropTypes.shape({}),
  networkLogo: PropTypes.string,
  rendered: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  backgroundUrl: PropTypes.string,
  dismiss: PropTypes.func,
};

PreviewPassWelcome.defaultProps = {
  sharedTheme: {},
  networkLogo: '',
  backgroundUrl: null,
  rendered: false,
  children: null,
  dismiss: () => {},
};

export default PreviewPassWelcome;
